import React from 'react';
import { motion } from 'framer-motion';
export function BonusSection() {
  return <section className="w-full py-10 md:py-16 px-4 bg-[#FDF6F0]" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-center mb-6 md:mb-10 text-brand-text-primary" data-id="element-19">
          Además, Hoy Recibís <span className="text-brand-gold" data-id="element-20">GRATIS:</span>
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8" data-id="element-21">
          {/* Bonus 1 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="relative bg-white border border-brand-gold/40 rounded-2xl p-4 md:p-6 overflow-hidden hover:border-brand-gold/80 transition-colors duration-300 shadow-sm" data-id="element-22">
            <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-20" data-id="element-23">
              GRATIS
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-center" data-id="element-24">
              <img src="https://cdn.magicpatterns.com/uploads/57cFcbL4WYzHS2UcAo4FP1/Bono_1.png" alt="Bono 1 Cocina Biohacker" className="w-32 md:w-40 rounded-lg shadow-md" data-id="element-25" />
              <div data-id="element-26">
                <h3 className="text-xl font-bold text-brand-gold mb-2" data-id="element-27">
                  LA COCINA BIOHACKER
                </h3>
                <p className="text-sm text-brand-text-muted mb-2 uppercase font-semibold" data-id="element-28">
                  Recetario de 28 Días Adaptado al Mercado Argentino
                </p>
                <p className="text-brand-text-body text-sm mb-4" data-id="element-29">
                  Recetas reales con ingredientes de cualquier súper argentino,
                  organizadas por fase del ciclo. Incluye lista de compras
                  semanal.
                </p>
                <p className="text-sm text-brand-text-muted" data-id="element-30">
                  Valor real:{' '}
                  <span className="line-through text-[#C94060] font-bold" data-id="element-31">
                    $14.990
                  </span>
                </p>
              </div>
            </div>
          </motion.div>

          {/* Bonus 2 */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="relative bg-white border border-brand-gold/40 rounded-2xl p-4 md:p-6 overflow-hidden hover:border-brand-gold/80 transition-colors duration-300 shadow-sm" data-id="element-32">
            <div className="absolute top-0 right-0 bg-brand-orange text-white text-xs font-bold px-3 py-1 rounded-bl-lg z-20" data-id="element-33">
              GRATIS
            </div>

            <div className="flex flex-col md:flex-row gap-4 md:gap-6 items-center" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/9YzPZxXzLEZd1tsyG7iDp9/Bono_2.png" alt="Bono 2 Protocolo Movimiento" className="w-32 md:w-40 rounded-lg shadow-md" data-id="element-35" />
              <div data-id="element-36">
                <h3 className="text-xl font-bold text-brand-gold mb-2" data-id="element-37">
                  PROTOCOLO DE MOVIMIENTO
                </h3>
                <p className="text-sm text-brand-text-muted mb-2 uppercase font-semibold" data-id="element-38">
                  Entrenamiento Cíclico Anti-Cortisol
                </p>
                <p className="text-brand-text-body text-sm mb-4" data-id="element-39">
                  Calendario completo de ejercicios por fase listo para
                  imprimir. Adaptaciones para casa y gimnasio.
                </p>
                <p className="text-sm text-brand-text-muted" data-id="element-40">
                  Valor real:{' '}
                  <span className="line-through text-[#C94060] font-bold" data-id="element-41">
                    $9.990
                  </span>
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}